'use strict';
var app = require('angular').module('dashboard');

app.controller('dashboardDepartmentAdminTagSyncCtrl', ['$uibModal', 'dialog', 'Department', 'Member', '$state', 'departments', '$translate', 'myTenant', require('./dashboardDepartmentAdminTagSyncCtrl')]);
app.controller('dashboardDepartmentAdminTagSyncImportCtrl', ['$uibModal', 'dialog', 'Department', 'Member', '$state', 'departments', '$translate', 'myTenant', require('./dashboardDepartmentAdminTagSyncImportCtrl')]);
app.config(['$stateProvider', require('./dashboardDepartmentAdminTagSyncConfig')]);
